import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AuthModule } from '@/store/modules/auth';
import { getNotificationsDoc } from '@/api/notifications';

export interface INotificationDoc {
  id: string,
  senderLastName: string,
  senderName: string,
  senderMiddleName: string,
  recipientLastName: string,
  recipientName: string,
  recipientMiddleName: string,
  recipientInn: string,
  recipientEmail: string,
  fileLink: string,
  createDate: string,
  isNew: boolean,
}

export interface INotificationDocState {
  list: INotificationDoc[];
  listNew: INotificationDoc[];
  totalCount: number
  newCount: number

  pagination: {
    pageNumber: number
    pageSize: number
  }
}

@Module({ dynamic: true, store, name: 'notificationsDoc', namespaced: true })
class NotificationsDoc extends VuexModule implements INotificationDocState {
  list = [];
  listNew = [];
  totalCount = 0;
  newCount = 0;

  pagination = {
    pageNumber: 0,
    pageSize: 15,
  };

  get paramsEsia() {
    return AuthModule.paramsEsia;
  }

  @Mutation
  setList(payload: INotificationDoc[]) {
    // @ts-ignore
    this.list = payload;
  }

  @Mutation
  setListNew(payload: INotificationDoc[]) {
    // @ts-ignore
    this.listNew = [...payload];
  }

  @Mutation
  setTotalCount(val: number) {
    this.totalCount = val;
  }

  @Mutation
  setNewCount(val: number) {
    this.newCount = val;
  }

  @Mutation
  setPageSize(payload: number) {
    this.pagination.pageSize = payload;
  }

  @Mutation
  setPageNumber(payload: number) {
    this.pagination.pageNumber = payload;
  }

  @Action
  changePageSize(payload: number) {
    this.setPageSize(payload);
  }

  @Action
  changePageNumber(payload: number) {
    this.setPageNumber(payload);
  }

  @Action
  async getNotificationsDoc() {
    const query = {
      pageNumber: this.pagination.pageNumber,
      pageSize: this.pagination.pageSize,
    };
    try {
      const { items, count } = await getNotificationsDoc(query);
      this.setList(items);
      this.setTotalCount(count);
    } catch (error) {
      // console.log('getNotificationsDoc error')
    }
  }

  @Action
  async getNotificationsDocNew() {
    const query = {
      pageNumber: 0,
      pageSize: 3,
      onlyNew: true,
    };
    try {
      const { items, count } = await getNotificationsDoc(query);
      this.setListNew(items);
      this.setNewCount(count);
    } catch (error) {
      // console.log('getNotificationsDocNew error')
    }
  }
}

export const NotificationDocModule = getModule(NotificationsDoc);
